<template>
  <div class="gj-table-wrapper-loading">
    <gj-table
        :data="tableData"
        adaptParent
        :columns="columns"
        :index="false"
        :adapt-height="false"
        :height="485"
        :loading="loading"
    >
      <template v-slot:productInfo="{row}">
        <div>
          <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
        </div>
        <div>
          <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
        </div>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin} from "../../../../../minxins";
  import {getQuotedLog} from "../../../../../api/purchase";

  export default {
    name: "app-supplier-detail-quoted-log",
    mixins: [queryMixin],
    props: {
      code: null,
    },
    created() {
      this.loading = true;
      getQuotedLog(this.code)
        .then((data) => {
          this.tableData = data;
        }).complete(() => this.loading = false)
    },
    data() {
      return {
        columns: [
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '140px'},
          {id: 'currency', header: '币种', field: 'currency', minWidth: '100px'},
          {id: 'excludeTaxPrice', header: '不含税单价', field: 'excludeTaxPrice', minWidth: '100px'},
          {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', minWidth: '100px'},
          {id: 'invoiceTaxRate', header: '票面税率', field: 'invoiceTaxRate', minWidth: '100px'},
          {id: 'actualTaxRate', header: '实际税率', field: 'actualTaxRate', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '130px'},
        ],
        tableData: [],
      }
    },
  }
</script>

<style scoped>

</style>
